<template>
  <HeadView :loading="loading"></HeadView>
  <v-app app>
    <v-navigation-drawer v-model="ver_menu_lateral" expand-on-hover v-if="$route.name !== 'LOGIN' && $route.name !== 'ELIMINAR_CUENTA_DE_CLIENTE'">
      <div class="text-right">
        <v-btn icon @click="mostrarMenuLateral()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <v-list density="comfortable" nav v-if="$route.name !== 'LOGIN' && $route.name !== 'ELIMINAR_CUENTA_DE_CLIENTE'"> <!-- comfortable // compact -->
        <v-list-item prepend-icon="mdi-home" title="Home" value="home" @click="goView('/')"></v-list-item>
        <v-list-item prepend-icon="mdi-silverware-variant" title="Pedidos" value="customer_orders" @click="goView('/customer_orders')"></v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <v-navigation-drawer v-model="ver_menu_tres_puntos" expand-on-hover location="right" v-if="$route.name !== 'LOGIN' && $route.name !== 'ELIMINAR_CUENTA_DE_CLIENTE'">
      <v-spacer></v-spacer>
      <v-btn icon @click="mostrarMenuTresPuntos()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-list density="comfortable" nav v-if="$route.name !== 'LOGIN' && $route.name !== 'ELIMINAR_CUENTA_DE_CLIENTE'"> <!-- comfortable // compact -->
        <v-list-item prepend-icon="mdi-account-circle" title="Cuenta" value="cuenta" @click="viewAccount()"></v-list-item>
        <v-list-item prepend-icon="mdi-logout" title="Cerrar Sesión" value="cerrar_sesion" @click="cerrarSesion()"></v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <v-app-bar color="teal-darken-4" v-if="$route.name !== 'LOGIN' && $route.name !== 'ELIMINAR_CUENTA_DE_CLIENTE'">
      <template v-slot:image>
        <v-img gradient="to top right, rgba(19,84,122,.8), rgba(128,208,199,.8)"></v-img>
      </template>
      <template v-slot:prepend>
        <v-app-bar-nav-icon v-if="!ver_menu_lateral" @click="mostrarMenuLateral()"></v-app-bar-nav-icon>
      </template>
      <v-app-bar-title>{{$route.name}}</v-app-bar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="viewPeopleInChat()">
        <v-icon v-if="iconmessagescount==0">mdi-facebook-messenger</v-icon>
        <v-icon color="yellow-lighten-1" v-if="iconmessagescount>0">mdi-facebook-messenger</v-icon>
      </v-btn>      
      <Chat @iconmsg="iconm()"/>
      <v-btn icon @click="mostrarMenuTresPuntos()">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-app-bar>
    
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Cuenta - Customer</span>
        </v-card-title>
        <v-container fluid>
          <v-row justify="space-around">
            <v-col cols="12" sm="2" md="6">
              <v-text-field
                type="input"
                v-model="account.type_document"
                color="purple darken-2"
                label="Tipo de Documento"
                autocomplete="off"
                variant="outlined"
                density="compact"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="6">
              <v-text-field
                type="input"
                v-model="account.document"
                color="purple darken-2"
                label="Nro Documento"
                autocomplete="off"
                variant="outlined"
                density="compact"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="12">
              <v-text-field
                type="input"
                v-model="account.first_name"
                color="purple darken-2"
                label="Nombres"
                autocomplete="off"
                variant="outlined"
                density="compact"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="12">
              <v-text-field
                type="input"
                v-model="account.last_name"
                color="purple darken-2"
                label="Apellidos"
                autocomplete="off"
                variant="outlined"
                density="compact"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="6">
              <v-text-field
                type="input"
                v-model="account.phone"
                color="purple darken-2"
                label="Teléfono"
                autocomplete="off"
                variant="outlined"
                density="compact"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="6">
              <v-text-field
                type="input"
                v-model="account.vehicle"
                color="purple darken-2"
                label="Vehículo"
                autocomplete="off"
                variant="outlined"
                density="compact"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="12">
              <v-text-field
                type="input"
                v-model="account.email"
                color="purple darken-2"
                label="E-mail"
                autocomplete="off"
                variant="outlined"
                density="compact"
                readonly
              ></v-text-field>
            </v-col>
            </v-row>
            <v-row>
              <v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined dark class="mb-2" color="blue darken-1" @click="close()">
                  <v-icon dark left>mdi-minus-circle</v-icon>Aceptar                          
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>    

    <v-dialog v-model="dialogchat" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Chat con {{ name_chat }}</span>
        </v-card-title>
        <v-container fluid>

          <v-row justify="space-around">
            <v-col cols="12" sm="2" md="12">
              <div v-for="message in messages" :key="message">
                <table width="100%">
                  <tr>
                    <td class="my-td-right-class" v-if="message.vendor_customer=='C'">
                      {{ message.message }}
                    </td>
                    <td class="my-td-left-class" v-else>
                      {{ message.message }}
                    </td>
                  </tr>
                </table>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-card-text>
              <v-text-field
                class="text-green"
                :loading="loading"
                density="compact"
                label="Mensaje"
                variant="solo"
                outline
                v-model="new_msg"
                type="input"
                color="red"
                bg-color="#eafaf1"
                :rules="rulestxt"
                counter="37"
                maxlength="37"                
              ></v-text-field>
            </v-card-text>
          </v-row>
          
          <v-row dense>
            <v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark class="mb-2" color="red darken-1" @click="close()">
                  <v-icon dark left>mdi-minus-circle</v-icon>Cerrar Chat        
                </v-btn>
                <!--<v-spacer></v-spacer>-->
                <v-btn dark class="mb-2" color="green darken-1" @click="addNewMessage()" :disabled="new_msg==''">
                  <v-icon dark left>mdi-send</v-icon>Enviar
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="12">
              <v-btn dark block class="mb-2" color="blue darken-1" @click="makeorder()">
                Hacer Pedido
              </v-btn>
            </v-col>
          </v-row>          
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_people_in_chat" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Vendedores en el Chat</span>
        </v-card-title>
        <v-container fluid>
          <v-row justify="space-around">    
            <v-col cols="12" sm="2" md="12">
              <v-select
                :items="people_in_chat"
                item-value="id"
                item-title="name"
                v-model="user_id_vendor"
                density="compact"
                label="Vendedor"
                color="purple darken-2"
              ></v-select>
            </v-col>
          </v-row>           

          <v-row>
            <v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark class="mb-2" color="red darken-1" @click="close()">
                  <v-icon dark left>mdi-minus-circle</v-icon>Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn dark class="mb-2" color="green darken-1" @click="viewChat()">
                  <v-icon dark left>mdi-send</v-icon>Chatear
                </v-btn>                
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
  import Home from './components/Home';
  import ChatVue from './components/Chat';
  import Swal from 'sweetalert2';
  import API from './api';
  import HeadView from './components/HeadView.vue';

  import {getFirestore,onSnapshot,collection,doc,deleteDoc,setDoc,addDoc,orderBy,where,query,serverTimestamp,limit,runTransaction,getCountFromServer, endAt, startAt} from 'firebase/firestore';
  import {initializeApp} from "firebase/app";
  import {getAnalytics} from "firebase/analytics";
  import {ref,onUnmounted} from 'vue';

  const firebaseConfig = {
    apiKey: "AIzaSyCVyZWY2af-JJf2V-gvVPFAW7ANDWzJNI0",
    authDomain: "cropchien-b4abf.firebaseapp.com",
    projectId: "cropchien-b4abf",
    storageBucket: "cropchien-b4abf.appspot.com",
    messagingSenderId: "980970251855",
    appId: "1:980970251855:web:df66971ae5ed35025eec3a",
    measurementId: "G-JZQ3Q4D3F3"
  };
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  const db = getFirestore(app);
  const updated_at_timestamp = serverTimestamp();
  
  export default {
    name: 'App',
    components: {
      Home,
      HeadView,
      Chat: ChatVue
    },
    data () {
      return {
        ver_menu_lateral: false,
        ver_menu_tres_puntos: false,
        token_street_shopping: null,
        dialog: false,
        account: {
          type_document: null,
          document: null,
          first_name: null,
          last_name: null,
          phone: null,
          email: null,
          vehicle: null
        },
        is_user_connected: "false",
        order_accepted: 0,
        messages:ref([]),
        iconmessages:ref([]),
        iconmessagescount: 0,
        dialogchat: false,
        dialog_people_in_chat: false,
        name_chat: '',
        mounted_msg: false,
        new_msg: '',
        user_id_customer: null,
        user_id_vendor: null,
        current_date: null,
        loaded: false,
        loading: false,
        address_id_customer: null,
        category_id: null,
        rulestxt: [v => v.length <= 37 || 'Max 37 characters'],   
      }
    },
    methods: {
      mounted() {
      },
      
      iconm() {
        const iconQuery = query(collection(db,"chat"),
          where("user_id_customer", "==", parseInt("38")),
          where("date_msg", "==", "2025-03-30"),
          limit(1)
        );
        const iconmessages = onSnapshot(iconQuery,(snapshot)=>{          
          this.iconmessagescount = 0;
          this.iconmessages = snapshot.docs.map((doc) => {
            this.iconmessagescount = 1;
          });
        });
      },
      
      getData() {
        if (this.user_id_customer == null) {
          let user_id_customer = localStorage.getItem('user_id_customer_street_shopping');
          if (user_id_customer != null) {
            this.user_id_customer = parseInt(user_id_customer);
            this.current_date = localStorage.getItem('current_date_street_shopping');
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },      

      viewChat() {
        if (this.getData()) {
          const namechat = this.people_in_chat.filter((vendor) => {
            return vendor.id == this.user_id_vendor;
          });
          if (namechat[0].name != undefined) {
            this.name_chat = namechat[0].name;
          }
          const latestQuery = query(collection(db,"chat"),
            where("user_id_customer", "==", parseInt(this.user_id_customer)),
            where("user_id_vendor", "==", parseInt(this.user_id_vendor)),
            where("date_msg", "==", this.current_date),            
            orderBy("updated_at"), startAt(1), limit(100)
          );

          const livemessages = onSnapshot(latestQuery,(snapshot)=>{
            this.messages = snapshot.docs.map((doc) => {
              return {
                id: doc.id,
                name: doc.data().name,
                vendor_customer: doc.data().vendor_customer,
                message: doc.data().message                
              }
            });
          });
          onUnmounted(livemessages);
          this.dialogchat = true;
        }
      },
      
      viewPeopleInChat() {
        if (this.getData()) {
          this.loading = true;
          this.ver_menu_tres_puntos = false;
          this.token_street_shopping = localStorage.getItem('token_street_shopping');
          let formdata = new FormData();
          formdata.append('is_customer', true);
          API.post('api.php', formdata, { headers: {
            'Authorization': this.token_street_shopping,
            'Route': 'get_people_in_chat'
          }}).then(response => {
            if (response.data.transaction_status && response.data.transaction_status.code == 200) {
              if (response.data.count > 0) {
                this.people_in_chat = response.data.Data;              
                this.user_id_vendor = this.people_in_chat[0].id;
                this.name_chat = this.people_in_chat[0].name;
                this.dialog_people_in_chat = true;
              } else {
                Swal.fire({
                title: 'Atención',
                html: 'No hay vendedores en el Chat',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
              });
              }
            } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
              localStorage.removeItem('token_street_shopping');
              this.goView('/login');
            } else {
              Swal.fire({
                title: 'Error interno',
                html: 'Se ha presentado una falla en el servidor',
                icon: 'error',
                confirmButtonText: 'Aceptar',
              });
            }
          }).catch(error => {
            Swal.fire({
              title: 'Error en la App',
              html: 'Se ha presentado una falla en la App',
              icon: 'error',
              confirmButtonText: 'Aceptar',
            });
          })
          .finally(() => this.loading = false)          
        }
      },

      goView(path_route) {
        if (path_route === '/chat') {
          this.$router.push(path_route);
        } else {
          this.ejectApp();
          if (this.order_accepted == 0 && this.is_user_connected == 'false') {
            this.$router.push(path_route);
          }
        }
        this.ver_menu_tres_puntos = false;
        this.ver_menu_lateral = false;
      },

      ejectApp() {
        this.is_user_connected = localStorage.getItem('is_connected_street_shopping');
        this.order_accepted = localStorage.getItem('order_accepted_street_shopping');
        if (this.order_accepted == null) {
          this.order_accepted = 0;
        }
        if (this.is_user_connected == null) {
          this.is_user_connected = 'false';
        }
      },

      mostrarMenuLateral() {
        this.ejectApp();
        if (this.order_accepted == 0 && this.is_user_connected == 'false') {
          this.ver_menu_tres_puntos = false;
          this.ver_menu_lateral = !this.ver_menu_lateral;
        } else {
          this.ver_menu_lateral = false;
        }
      },

      mostrarMenuTresPuntos() {        
        this.ver_menu_lateral = false;
        this.ver_menu_tres_puntos = !this.ver_menu_tres_puntos;
      },

      cerrarSesion() {
        this.ver_menu_tres_puntos = false;
        this.ver_menu_lateral = false;
        localStorage.removeItem('token_street_shopping');    
        this.goView('/login');
      },

      close() {
        this.dialog = false;
        this.dialogchat = false;
        this.dialog_people_in_chat = false;
      },

      viewAccount() {
        this.loading = true;
        this.ver_menu_tres_puntos = false;
        this.token_street_shopping = localStorage.getItem('token_street_shopping');
        let formdata = new FormData();
        API.post('api.php', formdata, { headers: {
          'Authorization': this.token_street_shopping,
          'Route': 'get_account_details'
        }}).then(response => {
          if (response.data.transaction_status && response.data.transaction_status.code == 200) {
            this.account = response.data.Data;
            this.dialog = true;
          } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
            localStorage.removeItem('token_street_shopping');
            this.goView('/login');
          } else {
            Swal.fire({
              title: 'Error interno',
              html: 'Se ha presentado una falla en el servidor',
              icon: 'error',
              confirmButtonText: 'Aceptar',
            });
          }
        }).catch(error => {
          Swal.fire({
            title: 'Error en la App',
            html: 'Se ha presentado una falla en la App',
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
        }).finally(() => this.loading = false)
      },

      addNewMessage() {
        addDoc(collection(db,'chat'),{
          message: this.new_msg,
          vendor_customer: "C",
          user_id_customer: parseInt(this.user_id_customer),
          user_id_vendor: parseInt(this.user_id_vendor),
          updated_at: updated_at_timestamp,
          date_msg: this.current_date,
          ready_for_vendor: 0,
        });
        this.new_msg = '';
      },

      makeorder() {
        this.loading = true;
        let formdata = new FormData();
        formdata.append('vendor_id', this.user_id_vendor);
        formdata.append('address_id', this.address_id_customer);
        formdata.append('category_id', this.category_id!=null ? this.category_id : 9999999);
        API.post('api.php', formdata, { headers: {
          'Authorization': this.token_street_shopping,
          'Route': 'set_create_order'
        }}).then(response => {
          if (response.data.transaction_status && response.data.transaction_status.code == 200) {
            if (response.data.Data.order_id != undefined && response.data.Data.order_id > 0) {
              Swal.fire({
                title: 'Atención',
                html: 'Se creo nueva orden, pronto recibiras el pedido',
                icon: 'info',
                confirmButtonText: 'Aceptar',
              });
              this.dialogchat = false;       
            } else {
              Swal.fire({
                title: 'Atención',
                html: 'No se pudo generar el pedido, intenta nuevamente',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
              });
            }
          } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
            localStorage.removeItem('token_street_shopping');
            this.$router.push("/login");
          } else {
            Swal.fire({
              title: 'Error',
              html: 'Fallas en el servidor, intenta nuevamente',
              icon: 'error',
              confirmButtonText: 'Aceptar',
            });
          }
        }).catch(error => {
          Swal.fire({
            title: 'Error',
            html: 'Se ha presentado un error, intenta nuevamente ',
            icon: 'error',
            confirmButtonText: 'Aceptar',
          });
          console.log('error front ' + error);
        }).finally(() => this.loading = false)
      },
      
    }
  }
</script>

<style>
  #map {
    height:100%;
    width:100%
  }

  .my-td-left-class {
    text-align: left !important;
    color:black !important;
  }

  .my-td-right-class {
    text-align: right !important;
    color:red !important;
    background-color: #eafaf1
  }
  
  .text-green input {
    color: red !important;
  }

  .swal2-confirm{
    background-color: green !important;
    color: #FFFFFF !important;
  }
  
  .swal2-cancel{
    background-color: red !important;
    color: #FFFFFF !important;
  }

  .swal2-container {
    z-index: 20000 !important;
  }

  .swal2.timerProgressBar {
    background-color: magenta !important; 
    color:  magenta !important;
    height: 1rem
  }
</style>